{
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "ContactDefinitions",
  "definitions": {
    "ContactSchema": {
      "type": "object",
      "required": [
        "id",
        "created_by",
        "created_at",
        "deleted_by",
        "deleted_at",
        "is_archived",
        "name",
        "email",
        "profile_id",
        "is_student",
        "meta"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "created_by": {
          "type": "string",
          "format": "uuid"
        },
        "created_at": {
          "type": "string",
          "format": "date-time"
        },
        "deleted_by": {
          "type": ["string", "null"],
          "format": "uuid"
        },
        "deleted_at": {
          "type": ["string", "null"],
          "format": "date-time"
        },
        "is_archived": {
          "description": "Mark this student as archived",
          "type": "boolean",
          "default": false
        },
        "name": {
          "type": "string",
          "minLength": 2
        },
        "email": {
          "type": ["string", "null"],
          "format": "email"
        },
        "is_student": {
          "description": "Show this contact in student results",
          "type": "boolean"
        },
        "associated_user_id": {
          "description": "Associate this contact with a user profile",
          "type": ["string", "null"],
          "format": "uuid"
        },
        "invite_id": {
          "description": "The invite to associate this contact with another user on Soniq",
          "type": ["string", "null"],
          "format": "uuid"
        },
        "invited_contact_id": {
          "description": "Associate this contact with another user on Soniq",
          "type": ["string", "null"],
          "format": "uuid"
        },
        "profile_id": {
          "description": "The profile which owns this contact",
          "type": "string"
        },
        "lesson_invoice_setting_id": {
          "description": "The invoice setting to use when creating invoices for lessons",
          "type": ["string", "null"],
          "format": "uuid"
        },
        "billing_contact_id": {
          "description": "Send invoice to this contact instead",
          "type": ["string", "null"],
          "format": "uuid"
        },
        "meta": {
          "description": "Structured custom metadata about the contact",
          "type": "object"
        },
        "user_id": {
          "description": "@deprecated",
          "type": ["string", "null"]
        },
        "teacher_user_id": {
          "description": "@deprecated use contact_relationship",
          "type": ["string", "null"]
        }
      }
    }
  }
}
